const map = {
  FxCustAccountList: () => import('@/views/fundingCenter/FxCustAccount/index'), // 客户账户管理
  FxAccountReconConfigList: () => import('@/views/fundingCenter/FxAccountReconConfig/index'), // 分销对账自动生成配置
  FxCustAccountDetail: () => import('@/views/fundingCenter/FxCustAccount/Detail'), // 客户账户详情
  FxAccountAdjustDetail: () => import('@/views/fundingCenter/FxAccountAdjust/Detail'), // 客户账户调整详情
  FxExpenseApplyList: () => import('@/views/fundingCenter/FxExpenseApply/index'), // 费用申请列表
  FxExpenseApplyDetail: () => import('@/views/fundingCenter/FxExpenseApply/Detail'), // 费用申请详情
  FxRefundApplicationList: () => import('@/views/fundingCenter/FxRefundApplication/index'), // 退款申请列表
  FxRefundApplicationDetail: () => import('@/views/fundingCenter/FxRefundApplication/Detail') // 退款申请详情
}

export default map
